<template>
  <div>
    <slot></slot>
  </div>
</template>

<script lang="js">
import Swiper, { Navigation } from 'swiper';
import leftPad from '../../js/util/leftPad';

Swiper.use([Navigation]);

export default  {
  name: 'ahc-slideshow',
  data() {
    return {
      swiperInstance: null
    }
  },
  props: {
    lazyLoad: {
      type: Boolean,
      required: false
    },
    loopedSlides: {
      type: Number,
      required: false,
      default: 1,
    },
    swipeRight: {
      type: Function,
      required: false,
    },
    swipeLeft: {
      type: Function,
      required: false,
    }
  },
  methods: {
    initSwiper() {
      const swiperContainer = this.$el.querySelector('.slideshow');
      const swiperSlides = this.$el.querySelectorAll('.slideshow__slide');
      const slideCounters = this.$el.querySelectorAll('.slideshow__slide-media-caption-counter');

      Array.prototype.forEach.call(slideCounters, (counter, index) => {
        counter.textContent = leftPad(index + 1, 2, '0') + '/' + leftPad(swiperSlides.length, 2, '0');
      });

      this.swiperInstance = new Swiper(swiperContainer, {
        loop: true,
        slidesPerView: 'auto',
        loopedSlides: this.loopedSlides,
        a11y: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
      });

      // This fixes an issue with looping not regenerating correctly when lazy loading images
      if (this.lazyLoad) {
        this.swiperInstance.once('transitionStart',function updateDuplicates() {
          this.loopDestroy()
          this.loopCreate()
        })
      }

      if (this.swipeLeft) {
        this.swiperInstance.on('slideNextTransitionStart', () => {
          this.swipeLeft()
        });
      }

      if (this.swipeRight) {
        this.swiperInstance.on('slidePrevTransitionStart', () => {
          this.swipeRight();
        });
      }
    }
  },
  mounted() {
    this.initSwiper();
  }
}
</script>

<style lang="scss">
@import "slideshow";
</style>
